module.exports = __webpack_public_path__ + "img/67-r.55c5caa5.png";